module.exports = require('./helpers/bundle-url').getBundleURL('8sReV') + "logo.c51670a8.svg";